'use strict';

exports.__esModule = true;
exports.default = defineRoutes;


/**
 * Define react-router-config routes, and assigns a key to each route.
 *
 * @param routes
 * @param idx
 * @returns {Array} Routes with a key value assigned to each route
 */
function defineRoutes(routes) {
    var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    routes.forEach(function (route) {
        route.key = typeof route.key !== 'undefined' ? route.key : idx++;
        if (Array.isArray(route.routes)) {
            defineRoutes(route.routes, idx);
        }
    });

    return routes;
}